/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
  path: '/',
  component: () => import('@/views/layouts/index'),
  redirect: '/home',
  meta: {
    title: '遥控',
    keepAlive: false
  },
  children: [{
    path: '/home',
    name: 'Home',
    component: () => import('@/views/index'),
    meta: {
      title: '遥控',
      keepAlive: false
    }
  }, {
    path: '/control',
    name: 'Control',
    component: () => import('@/views/control'),
    meta: {
      title: '遥控',
      keepAlive: false
    }
  }, {
    path: '/video',
    name: 'Video',
    component: () => import('@/views/video'),
    meta: {
      title: '视频',
      keepAlive: false
    }
  }, {
    path: '/test',
    name: 'testVideo',
    component: () => import('@/views/test'),
    meta: {
      title: '视频',
      keepAlive: false
    }
  }, {
    path: '/gamepad',
    name: 'GamepadComponent',
    component: () => import('@/views/gamepad'),
    meta: {
      title: '手柄遥控',
      keepAlive: false
    }
  }]
}];